import clsx from 'clsx'
import Link from 'next/link'

import cl from './Tabs.module.scss'

type TabLink = {
	link: string
	text: string
	isCurrent?: boolean
}

export interface TabsProps {
	regular: TabLink
	business: TabLink
}

export const Tabs = (props: TabsProps) => {
	const { regular, business } = props

	return (
		<div className={cl.tabs}>
			<div className={cl.container}>
				<div
					className={clsx(cl.regular, {
						[cl.regular__active]: regular.isCurrent
					})}>
					<Link prefetch={false} href={regular.link}>
						{regular.text}
					</Link>
				</div>
				<div
					className={clsx(cl.business, {
						[cl.business__active]: business.isCurrent
					})}>
					<Link prefetch={false} href={business.link}>
						{business.text}
					</Link>
				</div>
			</div>
		</div>
	)
}
